<template>
	<button @click="onClick" class="btn" :class="classes" :disabled="disabled">
		<slot name="icon" />
		<small style="font-weight: 300;"	>
			<slot />
		</small>
	</button>
</template>

<script>
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin]
}
</script>

<style scoped>
.btn-light {
	color: #212529;
	background-color: #e6e6e6;
	border-color: #e6e6e6;
}
.btn-text-light {
	color: #e6e6e6;
}
.btn-icon {
	padding: 4px;
	width: 41px;
	height: 41px;
}
@media (max-width: 1024px) {
	button {
		margin-bottom: 4px;
		width: 100%;
	}
}
</style>
